import { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "danger" | "ghost";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  full?: boolean;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
};

/**
 * 汎用ボタン
 * - onClick は呼び出し側必須。未指定なら何もしない(no-op)。
 *   「今は未実装」のような古いデモ文言は出さない(2026-09-19 削除)。
 */
export const Button = ({
  variant = "primary",
  full,
  iconLeft,
  iconRight,
  children,
  className,
  onClick,
  ...rest
}: ButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`btn btn-${variant} ${full ? "btn-full" : ""} ${className ?? ""}`}
      {...rest}
    >
      {iconLeft}
      {children}
      {iconRight}
    </button>
  );
};
